<div class="wrap-snack" [class]="css">
  {{'enums.ApiResult.' + data.message | translate}}
</div>
